import debounce from 'lodash/debounce';
import { useState } from 'react';
import useIsomorphicLayoutEffect from './useIsomorphicLayoutEffect';

// These are set to align with the min sizes within tailwind.config.js plus tailwind defaults
const BREAKPOINTS = {
  XXXS: 320,
  XXS: 375,
  XS: 425,
  SM: 640,
  MD: 768,
  LG: 1024,
  XL: 1280,
  XXL: 1536,
};

const useIsAboveBreakpoint = (breakpointKey: keyof typeof BREAKPOINTS, delay = 100): boolean => {
  const breakpoint = BREAKPOINTS[breakpointKey];
  const [isAboveBreakpoint, setIsAboveBreakpoint] = useState<boolean>(false);

  useIsomorphicLayoutEffect(() => {
    const debouncedHandleResize = debounce(() => {
      setIsAboveBreakpoint(window.innerWidth >= breakpoint);
    }, delay);

    debouncedHandleResize();
    window.addEventListener('resize', debouncedHandleResize);

    return () => {
      setIsAboveBreakpoint(window.innerWidth >= breakpoint);
      window.removeEventListener('resize', debouncedHandleResize);
    };
  }, [breakpoint, delay]);

  return isAboveBreakpoint;
};

export default useIsAboveBreakpoint;
